// extracted by mini-css-extract-plugin
export default {"card":"HotVacancyCard_card__Vjnd-","location":"HotVacancyCard_location__w1WWW","card__link":"HotVacancyCard_card__link__AR4fn","card__title":"HotVacancyCard_card__title__35TOP"};